import React, { useEffect } from 'react';
import { autorun } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useHistory } from 'react-router-dom';
import { Formik, Form, Field } from 'formik';
import { Box, Fab, Grid } from '@material-ui/core';
import { isEqual } from 'lodash';
import { TextField } from 'formik-material-ui';
import { Done as DoneIcon } from '@material-ui/icons';
import { AppBar, Page, ScreenLoader } from 'components';
import { reportStore, anketsStore } from 'stores';
import { ru } from 'locale';
import useStyles from './ReportEditScreen.styles';

const ReportEditScreen = observer(() => {
  const classes = useStyles();
  const history = useHistory();
  const { report, fetchState, formData } = reportStore;

  useEffect(
    () =>
      autorun(() => {
        reportStore.getReport(anketsStore.anketId);
      }),
    [],
  );

  const handleBackClick = () => {
    history.goBack();
  };

  const handleReportUpdate = newFormData => {
    if (!isEqual(formData, newFormData)) {
      reportStore.updateReport(anketsStore.anketId, newFormData);
    } else {
      handleBackClick();
    }
  };

  const renderForm = () => {
    const formFields = Object.keys(formData);

    return (
      <Grid item>
        <Box px={1} py={1}>
          <Formik initialValues={formData} onSubmit={handleReportUpdate} enableReinitialize>
            {() => {
              return (
                <Form className={classes.form} noValidate>
                  {formFields.map(fieldName => {
                    return (
                      <Box mb={2} key={fieldName}>
                        <Field
                          name={fieldName}
                          label={report[fieldName].title}
                          component={TextField}
                          autoFocus
                          autoComplete="off"
                          required
                          fullWidth
                          multiline
                        />
                      </Box>
                    );
                  })}

                  <Fab
                    type="submit"
                    color="secondary"
                    aria-label={ru.save}
                    className={classes.saveButton}
                  >
                    <DoneIcon />
                  </Fab>
                </Form>
              );
            }}
          </Formik>
        </Box>
      </Grid>
    );
  };

  return (
    <Page fullScreen style={{ minHeight: '100rvh' }}>
      <Grid container direction="column">
        <Grid item>
          <AppBar title={ru.editReport} onNavButtonClick={handleBackClick} />
        </Grid>

        {fetchState === 'pending' && <ScreenLoader />}
        {fetchState === 'fulfilled' && renderForm()}
      </Grid>
    </Page>
  );
});

export default ReportEditScreen;
